import { createAction } from '../../../store.model';
import { SortOptions } from '../../table';
import { ActionType } from '../main.action';

export interface SortRows {
    options: SortOptions;
}

export const sortRows = createAction<ActionType, SortRows>(
    ActionType.MI2_MAIN__SORT_ROWS,
);
